import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import {Observable, of, Subject, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
@Injectable()

export class AuthenticationService {
	constructor(private http: HttpClient) { }

	/*newLogin(username: string, password: string):Observable<any>{
        let url ="https://erisservice.ecologeris.com/erisExt/weborder_v2_prod/OrderForm.svc/getLoginNew";//"http://localhost:8130/OrderForm.svc/getLoginNew";//
		let orderData = {"uname": username, "upass":password};
		
		return this.http.post<any>(`${environment.api.getReportList}`, orderData, {
			headers: new HttpHeaders({'Content-Type':  'application/json'}),
			responseType: 'json'
		});
		.pipe(
			retry(1),
			catchError(this.handleError)
      
		);
		
	}*/
	
	/* logout(customerId:string, sKey:string):Observable<any>{ 
        let url ="https://erisservice.ecologeris.com/erisExt/weborder_v2_prod/OrderForm.svc/DeleteSession";//"http://localhost:8130/OrderForm.svc/DeleteSession";//
		let orderData = {"customerid": customerId, "stringData":sKey};
		return this.http.post<any>(`${environment.api.getReportList}`, orderData, {
			headers: new HttpHeaders({'Content-Type':  'application/json'}),
			responseType: 'json'
		});
		.pipe(
			retry(1),
			catchError(this.handleError)
      
		);

  }*/
	
	

}


